import React, { useId, useLayoutEffect, useRef, useState } from "react";

const NAVY = "#0A1628";
const EMERALD = "#00C896";

function isDarkBackground(node) {
  for (let el = node?.parentElement; el; el = el.parentElement) {
    const m = getComputedStyle(el).backgroundColor.match(/[\d.]+/g);
    if (!m || (m.length === 4 && +m[3] < 0.5)) continue;
    const [r, g, b] = m.map(Number);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b < 140;
  }
  return false;
}

// Brand hourglass: sand flows top → bottom, then a half-turn flip and loop. Frame turns white on dark backgrounds.
export const FindoSpinner = ({ size = 40, className = "", light }) => {
  const ref = useRef(null);
  const uid = useId().replace(/:/g, "");
  const [auto, setAuto] = useState(false);
  useLayoutEffect(() => { if (light === undefined) setAuto(isDarkBackground(ref.current)); }, [light]);
  const frame = (light ?? auto) ? "#FFFFFF" : NAVY;
  return (
    <svg ref={ref} width={Math.round(size * 0.75)} height={size} viewBox="0 0 24 32" role="img" aria-hidden="true"
      className={`fl-hourglass inline-block shrink-0 ${className}`} data-testid="findo-spinner">
      <defs>
        <clipPath id={`hgt${uid}`}><path d="M7 4h10c0 6-4.2 9-4.2 11.6h-1.6C11.2 13 7 10 7 4z" /></clipPath>
        <clipPath id={`hgb${uid}`}><path d="M7 28h10c0-6-4.2-9-4.2-11.6h-1.6C11.2 19 7 22 7 28z" /></clipPath>
      </defs>
      <g className="fl-hg-body">
        <rect className="fl-hg-top" x="6" y="7" width="12" height="9" fill={EMERALD} clipPath={`url(#hgt${uid})`} />
        <rect className="fl-hg-bottom" x="6" y="19" width="12" height="9" fill={EMERALD} clipPath={`url(#hgb${uid})`} />
        <rect className="fl-hg-stream" x="11.5" y="15.5" width="1" height="12" fill={EMERALD} />
        <path d="M6 3.5C6 10 10.6 13 10.6 16S6 22 6 28.5M18 3.5C18 10 13.4 13 13.4 16S18 22 18 28.5" fill="none" stroke={frame} strokeWidth="1.7" strokeLinecap="round" />
        <rect x="3" y="1" width="18" height="2.6" rx="1.3" fill={frame} />
        <rect x="3" y="28.4" width="18" height="2.6" rx="1.3" fill={frame} />
      </g>
    </svg>
  );
};

export const PageLoader = ({ label, className = "py-32", size = 40, testid = "page-loader" }) => (
  <div className={`flex flex-col items-center justify-center gap-3 text-center text-slate-400 text-sm ${className}`} role="status" data-testid={testid}>
    <FindoSpinner size={size} />
    {label && <span>{label}</span>}
  </div>
);

export const WaitingNotice = ({ title, text, testid = "waiting-notice", children }) => (
  <div className="flex items-start gap-3.5 rounded-2xl border border-findo-navy/15 bg-findo-navy/[0.04] p-4" data-testid={testid}>
    <div className="min-w-0 flex-1">
      <p className="text-sm font-semibold text-findo-navy">{title}</p>
      {text && <p className="text-xs text-slate-500 mt-1 leading-relaxed">{text}</p>}
      {children}
    </div>
  </div>
);
